<template>
  <div class="form-container">
    <div v-if="isLoading">
      <h2>個人資料</h2>
      <form>
        <div class="name-container flex-container">
          <div class="flex-item">
            <div class="form-title">名字</div>
            <input
              type="text"
              v-bind:value="getMemberInfo.firstName"
              data-item="firstName"
              v-on:input="saveChangeInfo"
            />
          </div>
          <div class="flex-item">
            <div class="form-title">姓氏</div>
            <input
              type="text"
              v-bind:value="getMemberInfo.lastName"
              data-item="lastName"
              v-on:input="saveChangeInfo"
            />
          </div>
        </div>
        <div>
          <div class="form-title">手機</div>
          <input
            type="text"
            pattern="[0-9]{0,255}"
            oninvalid="setCustomValidity('請輸入手機號碼(純數字)')"
            v-bind:value="getMemberInfo.phone"
            data-item="phone"
            v-on:input="saveChangeInfo"
          />
        </div>
        <div>
          <div class="form-title">電子信箱</div>
          <input
            class="emailExamine"
            type="email"
            v-bind:value="getMemberInfo.email"
            data-item="email"
            v-on:input="saveChangeInfo"
          />
        </div>
        <div>
          <div class="form-title">住址</div>
          <!-- <div class="flex-container address"> -->
          <div class="address-container">
            <div class="flex-container">
              <input
                class="flex-item"
                type="text"
                placeholder="台灣"
                v-bind:value="getMemberInfo.country"
                data-item="country"
                v-on:input="saveChangeInfo"
              />
              <div class="dropdown-title flex-item">
                <a
                  href="#"
                  v-on:click.prevent="showDropDown_city = !showDropDown_city"
                >
                  <div :class="{ 'title-color': chooseCity === '' }">
                    {{ chooseCity ? chooseCity : "縣市" }}
                  </div>
                  <i
                    :class="{
                      'fa-caret-up': showDropDown_city,
                      'fa-caret-down': !showDropDown_city,
                    }"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </a>
                <transition name="slide-fade">
                  <div class="choice" v-if="showDropDown_city">
                    <ul>
                      <li
                        v-for="(city, index) in displayCityList"
                        :key="index"
                        @click="showDropDown_city = !showDropDown_city"
                      >
                        <span class="item" @click="chooseCity = city">{{
                          city
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
              <div class="dropdown-title flex-item">
                <a
                  href="#"
                  v-on:click.prevent="
                    showDropDown_zipcode = !showDropDown_zipcode
                  "
                >
                  <div :class="{ 'title-color': displayZipCodeInfo === '' }">
                    {{ displayZipCodeInfo ? displayZipCodeInfo : "郵遞區號" }}
                  </div>
                  <i
                    :class="{
                      'fa-caret-up': showDropDown_zipcode,
                      'fa-caret-down': !showDropDown_zipcode,
                    }"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </a>
                <transition name="slide-fade">
                  <div class="choice" v-if="showDropDown_zipcode">
                    <ul>
                      <li
                        v-for="(zipcode, index) in displayZipCodeList"
                        :key="index"
                        @click="showDropDown_zipcode = !showDropDown_zipcode"
                      >
                        <span
                          class="item"
                          @click="changeInfoData.postalCode = zipcode.zopcode"
                          >{{ zipcode.region + zipcode.zopcode }}</span
                        >
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            <!-- <input class="flex-item" type="text"  pattern="^[0-9]{0,255}" placeholder="郵遞區號" v-bind:value="getMemberInfo.postalCode" data-item="postalCode" v-on:input="saveChangeInfo"> -->
            <input
              type="text"
              placeholder="地址"
              v-bind:value="getMemberInfo.address"
              data-item="address"
              v-on:input="saveChangeInfo"
            />
            <div class="address-notice">此地址會是你的預設寄送地址</div>
          </div>
        </div>
      </form>
      <button v-on:click="sendAllChange">儲存變更</button>
      <div class="mobile_backNav" v-if="webElememtHide">
        <i class="fa fa-angle-left"></i>
        <router-link to="/gold/member_mobile">返回會員帳號</router-link>
      </div>
    </div>
    <div class="load" v-else>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import taiwanZipcodeData from "@/constData/taiwanZipCode.js";
export default {
  name: "memberForm",
  beforeRouteLeave(to, from, next) {
    if (this.changeInfo) {
      let userResponse = confirm("您尚未儲存資料，確定離開嗎？");
      if (userResponse) {
        next();
      }
    } else {
      next();
    }
  },
  data() {
    return {
      changeInfo: false,
      changeInfoData: "",
      showDropDown_city: false,
      showDropDown_zipcode: false,
      taiwanZipcodeData: taiwanZipcodeData.taiwanZipcodeData,
      chooseCity: "",
    };
  },
  watch: {
    getMemberInfo() {
      this.changeInfoData = this.$store.getters.getMemberInfo;
      if (this.changeInfoData.postalCode !== "") {
        this.chooseCity = this.$store.getters.getCityByZipcode(
          this.changeInfoData.postalCode
        );
      }
    },
  },
  created() {
    if (!this.$store.getters.getToken) {
      this.getToken();
      this.changeURL();
    }
    this.$store.dispatch("tokenGetMemberInfo");
  },
  methods: {
    getToken() {
      let responseUrl = window.location.search.substring(1);
      let keys = responseUrl.split("&");
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i].split("=");
        if (key[0] == "token") {
          this.$store.dispatch("setToken", key[1]);
          Cookies.set("goldUser", key[1], { expires: 14 });
        }
      }
    },
    changeURL() {
      let size = parseInt(this.$store.getters.getDeviceSize);
      if (size > 585) {
        this.$router.push("/gold/member/member_form");
      } else {
        this.$router.push("/gold/member_mobile");
      }
    },
    //本地component儲存
    saveChangeInfo(e) {
      this.changeInfo = true;
      this.changeInfoData[e.target.dataset.item] = e.target.value;
    },
    //發送api
    sendAllChange() {
      let checkResult = this.examineData();
      if (checkResult == "ok") {
        this.changeInfo = false;
        this.$store.dispatch("tokenSetMemberInfo", this.changeInfoData);
      } else {
        return;
      }
    },
    examineData() {
      let allInput = document.querySelectorAll("input");
      let email = document.querySelector(".emailExamine");
      allInput.forEach((item) => {
        item.style.border = "1px solid #a8894c";
      });
      email.style.border = "1px solid #a8894c";
      let errorData = document.querySelectorAll("input:invalid");
      let emailExamine = /^.*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      if (errorData.length !== 0) {
        alert("尚有聯絡資料格式錯誤");
        errorData.forEach((item) => {
          item.style.border = "2px solid red";
        });
        return "error";
      } else if (this.changeInfo.email == "") {
        if (!emailExamine.test(this.changeInfo.email)) {
          email.style.border = "2px solid red";
          return "error";
        }
      } else {
        return "ok";
      }
    },
  },
  computed: {
    getMemberInfo() {
      return this.$store.getters.getMemberInfo;
    },
    isLoading() {
      return !!this.$store.getters.getIsLoading;
    },
    webElememtHide() {
      let size = parseInt(this.$store.getters.getDeviceSize);
      if (size > 585) {
        return false;
      } else {
        return true;
      }
    },
    displayCityList() {
      let cityList = [];
      for (let city in this.taiwanZipcodeData) {
        cityList.push(city);
      }
      return cityList;
    },
    displayZipCodeList() {
      if (this.chooseCity !== "") {
        let zipcodeList = [];
        this.taiwanZipcodeData[`${this.chooseCity}`].forEach((item) => {
          let keyValue = Object.entries(item)[0];
          zipcodeList.push({
            region: keyValue[0],
            zopcode: keyValue[1],
          });
        });
        return zipcodeList;
      } else {
        return [];
      }
    },
    displayZipCodeInfo() {
      let displayZipCode = "";
      if (this.changeInfoData.postalCode === "" || this.chooseCity === "") {
        return "";
      } else {
        for (let cityValue in this.taiwanZipcodeData) {
          this.taiwanZipcodeData[`${this.chooseCity}`].forEach((region) => {
            for (let regionName in region) {
              if (region[`${regionName}`] === this.changeInfoData.postalCode) {
                displayZipCode = regionName + region[`${regionName}`];
              }
            }
          });
        }
        return displayZipCode;
      }
    },
  },
};
</script>

<style scoped lang="scss">
* {
  text-align: left;
  font-size: 17px;
  box-sizing: border-box;
}
h2 {
  color: $primaryDeepColor;
  font-size: 35px;
  margin: 0;
  @include betweenPhoneTable {
    padding-top: 20px;
  }
}
.form-container {
  max-width: 50.5%;
  color: $secondaryDeepColor1;
  @include betweenPhoneTable {
    max-width: 100%;
  }
}
.name-container {
  .flex-item {
    width: 48%;
    @include table {
      width: 100%;
    }
  }
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.address-container {
  .flex-item {
    width: 32%;
    @include table {
      width: 100%;
    }
  }
  .flex-container {
    margin-bottom: 15px;
    @include table {
      margin-bottom: 0;
    }
  }
  .address-notice {
    margin-bottom: 30px;
  }
  .flex-container > * {
    @include table {
      margin-bottom: 15px;
    }
  }
}
.form-title {
  margin-top: 15px;
  margin-bottom: 8px;
}
input {
  width: 100%;
  padding: 16px;
  font-size: 17px;
  border: 1px solid $primaryDeepColor;
  background-color: rgba(0, 0, 0, 0);
}
button {
  @extend %button;
  text-align: center;
  margin: 0; //消除預設 margin padding
  @include phone {
    width: 100%;
  }
}
a {
  display: block;
  color: $primaryDeepColor;
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    text-align: center;
  }
}

//loading
.load {
  padding-top: 120px;
  text-align: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}

//dropdown
.dropdown-title {
  position: relative;
  a,
  .item {
    color: $secondaryDeepColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    border: 1px $primaryDeepColor solid;
    padding: 15px 15px 15px 10px;
    width: 100%;
  }
  a {
    background-color: rgba(0, 0, 0, 0);
  }
  .item {
    background-color: #fefff9;
  }
  .item:hover {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
  .title-color {
    color: $secondaryLightColor1;
  }
}
ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 99;
  max-height: 365px;
  overflow-y: scroll;
}
.fa {
  margin-left: auto;
  color: $primaryLightColor;
}
</style>
